import { AddTaskButton } from './AddTaskButton.js';
import { AddCourseButton } from './AddCourseButton.js';

export function ActionButtons({
  defaultProjectId = null,
}: {
  defaultProjectId?: string | null;
}): React.ReactElement {
  return (
    <div className="flex items-center gap-2">
      <AddCourseButton />
      <AddTaskButton defaultProjectId={defaultProjectId} />
    </div>
  );
}
